// @flow
import React from 'react';
import { I18n } from '@lingui/react';

import { MQ } from '@rover/react-lib/styles';
import styled, { type StyledComponent } from 'styled-components';

import TextInput, { type Props } from '../../formFields/TextInput';

const StyledTextInput: StyledComponent<React$ElementConfig<typeof TextInput>, {}, any> = styled(
  TextInput
)`
  flex: 2;

  ${MQ.XS} {
    width: 100%;
    flex: none;
  }
`;

const AddresFormLine1Field = (props: Props) => (
  <I18n>
    {({ i18n }) => (
      <StyledTextInput
        sensitive
        label={i18n._('Address Line 1')}
        name="address-line1"
        placeholder={i18n._('Address Line 1')}
        autoComplete="address-line1"
        data-qa-id="input-text-address-line-1"
        {...props}
      />
    )}
  </I18n>
);

export default AddresFormLine1Field;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/AddressForm/AddressFormLine1Field.jsx